import React from 'react';
import Button from '@material-ui/core/Button';
import stylesParent from '../frame.module.scss';
import styles from '../styles/details.module.scss';
import { useGetTheme } from '../../../../hooks/useGetTheme';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Details = ({ title, textButton, buttonClick, stepBg, token, descriptions }) => {
  const colors = useGetTheme();
  return (
    <div className={stylesParent.cardContent} style={{ color: colors.text }}>
      <div className={cn({ [stylesParent.cardTextRow]: !stepBg })}>
        <div className={cn({ [stylesParent.cardTextRowLabel]: !stepBg, [styles.title]: !!stepBg })}>
          {title}
        </div>
        <div
          style={{ fontWeight: 800 }}
          className={cn({ [stylesParent.cardTextRowValue]: !stepBg, [styles.value]: !!stepBg })}
        >
          {token}
        </div>
      </div>
      <img className={styles.image} src={stepBg} alt='' />
      <div className={cn({ [styles.descriptionContainer]: !stepBg })}>
        {descriptions.map((description, index) => (
          <div key={description} className={styles.descriptionItem}>
            <span>{'*'.repeat(index + 1)}</span> {description}
          </div>
        ))}
      </div>
      <div className={stylesParent.cardFooterControls}>
        <Button
          onClick={buttonClick}
          variant='contained'
          color='secondary'
          className={stylesParent.cardFooterControlsButton}
        >
          {textButton}
        </Button>
      </div>
    </div>
  );
};

Details.propTypes = {
  title: PropTypes.string.isRequired,
  buttonClick: PropTypes.func.isRequired,
  stepBg: PropTypes.string,
  token: PropTypes.string.isRequired,
  textButton: PropTypes.string.isRequired,
  descriptions: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Details;
